import { Component, Inject, OnInit, Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import { SqlService } from '../../Database/sql.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-viewboxes',
  templateUrl: './viewboxes.component.html',
  styleUrls: ['./viewboxes.component.css'],
})
export class ViewboxesComponent implements OnInit {
  closeResult = '';
  DisplayErrormessage = '';
  PopupTitle = '';

  SearchValue = {
    Boxno: '',
    Provider: 'All',

    DateReceived: '',
    Status: 'Recieved',
    Branch: 'All',
    Distributor: 'All',
    Province: 'All',

    SerialNumber: 'All',
    DateDistributed: '',

    ClientName: 'All',
    ClientProvince: 'All',
    ClientCellNumber: 'All',

    DistributorStartDate: '',
    DistributorEndDate: '',

    RecievedStartDate: '',
    RecievedEndDate: '',

    ConnectionStartDate: '',
    ConnectionEndDate: '',

    ActivationStartDate: '',
    ActivationEndDate: '',
    ClientArea: '',
    BatchNumber: '',
    fake: '',
  };

  Providers = [''];
  ClientNames = [''];
  ClientProvinces = [''];
  Distributors = [''];

  data = [
    {
      Boxno: '',
      Provider: '',

      DateReceived: '',
      Status: '',
      Branch: '',
      Distributor: '',
      Province: '',

      SerialNumber: '',
      DateDistributed: '',

      ClientName: '',
      ClientProvince: '',
      ClientCellNumber: '',
      fake: '',

      Connection: '',
      Activation: '',
      ClientArea: '',
      BatchNumber: '',
    },
  ];

  p: number = 1;
  ItemsPerPage = 20;

  Amount = 0;

  iRowsLoaded = 0;

  constructor(
    private dbService: SqlService,
    private router: Router,
    private modalService: NgbModal,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.clearData();
    this.getAllProvidersDistributors();
    this.getData();
  }

  getAllProvidersDistributors() {
    this.Providers.splice(0);
    this.Distributors.splice(0);
    this.ClientNames.splice(0);
    this.ClientProvinces.splice(0);
    
    Swal.fire({
      title: 'Loading Boxes.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, // Prevents closing on outside click
      allowEscapeKey: false, // Prevents closing on Esc key
      willOpen: () => {
        Swal.showLoading();
      },
    });

    this.dbService.getAllProviders().subscribe((ret: any) => {
      if (ret != 'false') {
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach((element) => {
          let elementtemp = element.split(',');
          let temp = {
            ID: elementtemp[0],
            //1 -> BoxSizeDirect
            //2 -> BatchSizeDirect
            BoxSize: elementtemp[3],
            BatchSize: elementtemp[4],
          };

          this.Providers.push(temp.ID);
        });

        this.dbService.getAllDistrubutor().subscribe((ret: any) => {
          if (ret != 'false') {
            let a = (ret as string).split(';');
            a.splice(a.length - 1, 1);

            a.forEach((element) => {
              let elementtemp = element.split(',');
              let temp = {
                ID: elementtemp[0],
                Province: elementtemp[1],
                Active: elementtemp[2],
              };
              this.Distributors.push(temp.ID);
            });

            Swal.close();

            /*this.dbService.GetAllClients().subscribe((ret: any) => {
              if (ret != 'false') {
                let a = (ret as string).split(';');
                a.splice(a.length - 1, 1);

                a.forEach((element) => {
                  let elementtemp = element.split(',');
                  let temp = {
                    ID: elementtemp[0],
                    Province: elementtemp[1],
                    Area: elementtemp[2],
                  };

                  if (temp.Province != '') {
                    if (!this.ClientProvinces.includes(temp.Province)) {
                      this.ClientProvinces.push(temp.Province);
                    }
                  }
                });

                Swal.close();
              } else {
                this.PopupTitle = 'Something went wrong';
                this.DisplayErrormessage =
                  'Please check your internet connection and try again';
                let element: HTMLButtonElement = document.getElementById(
                  'ErrorButton'
                ) as HTMLButtonElement;
                element.click();
                Swal.close();
              }
            });*/
          } else {
            this.PopupTitle = 'Something went wrong';
            this.DisplayErrormessage =
              'Please check your internet connection and try again';
            let element: HTMLButtonElement = document.getElementById(
              'ErrorButton'
            ) as HTMLButtonElement;
            element.click();
            Swal.close();
          }
        });
      } else {
        this.PopupTitle = 'Something went wrong';
        this.DisplayErrormessage =
          'Please check your internet connection and try again';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });
  }

  clearData() {
    Swal.fire({
      title: 'Clearing filters.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, // Prevents closing on outside click
      allowEscapeKey: false, // Prevents closing on Esc key
      willOpen: () => {
        Swal.showLoading();
      },
    });

    this.iRowsLoaded = 0;
    this.data = [];
  }

  LoadMoreFields() {
    this.getData();
  }

  getData() {
    Swal.fire({
      title: 'Loading Boxes.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, // Prevents closing on outside click
      allowEscapeKey: false, // Prevents closing on Esc key
      willOpen: () => {
        Swal.showLoading();
      },
    });

    var formData = new FormData(); // Currently empty

    var SQLQuery = '';

    if (this.SearchValue.Boxno != '') {
      SQLQuery += "AND Boxes.Boxno like '" + this.SearchValue.Boxno + "%' ";
    }

    if (this.SearchValue.Provider != 'All') {
      SQLQuery += "AND Boxes.Provider='" + this.SearchValue.Provider + "' ";
    }

    if (this.SearchValue.Distributor != 'All') {
      SQLQuery +=
        "AND Boxes.Distributor='" + this.SearchValue.Distributor + "' ";
    }

    if (this.SearchValue.Province != 'All') {
      SQLQuery += "AND Boxes.Province='" + this.SearchValue.Province + "' ";
    }

    if (this.SearchValue.ClientName != 'All') {
      SQLQuery +=
        "AND BoxDetails.Client='" + this.SearchValue.ClientName + "' ";
    }

    if (this.SearchValue.ClientProvince != 'All') {
      SQLQuery +=
        "AND Clients.Province='" + this.SearchValue.ClientProvince + "' ";
    }

    if (
      this.SearchValue.DistributorStartDate != '' &&
      this.SearchValue.DistributorEndDate != ''
    ) {
      SQLQuery +=
        " AND BoxDetails.DateDist between '" +
        this.SearchValue.DistributorStartDate +
        "' AND '" +
        this.SearchValue.DistributorEndDate +
        "' ";
    }

    if (
      this.SearchValue.RecievedStartDate != '' &&
      this.SearchValue.RecievedEndDate != ''
    ) {
      SQLQuery +=
        " AND Boxes.DateReceived between '" +
        this.SearchValue.RecievedStartDate +
        "' AND '" +
        this.SearchValue.RecievedEndDate +
        "' ";
    }

    if (
      this.SearchValue.ConnectionStartDate != '' &&
      this.SearchValue.ConnectionEndDate != ''
    ) {
      SQLQuery +=
        " AND BoxDetails.condate between '" +
        this.SearchValue.ConnectionStartDate +
        "' AND '" +
        this.SearchValue.ConnectionEndDate +
        "' ";
    }
    if (
      this.SearchValue.ActivationStartDate != '' &&
      this.SearchValue.ActivationEndDate != ''
    ) {
      SQLQuery +=
        " AND BoxDetails.actdate between '" +
        this.SearchValue.ActivationStartDate +
        "' AND '" +
        this.SearchValue.ActivationEndDate +
        "' ";
    }

    console.log(SQLQuery);
    formData.set('SQLQuery', SQLQuery);
    formData.set('start', this.iRowsLoaded.toString());
    this.iRowsLoaded += 50;
    formData.set('end', this.iRowsLoaded.toString());
    formData.set('status', this.SearchValue.Status);

    this.dbService.getAllBoxes(formData).subscribe((ret: any) => {
      if (ret != 'false') {
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach((element) => {
          let elementtemp = element.split(',');
          let temp = {
            Boxno: elementtemp[0],
            Provider: elementtemp[1],

            DateReceived: elementtemp[2],
            Status: elementtemp[3],
            Branch: elementtemp[4],
            Distributor: elementtemp[5],
            Province: elementtemp[6],

            SerialNumber: elementtemp[7] + ',',
            DateDistributed: elementtemp[8],

            ClientName: elementtemp[9],
            ClientProvince: elementtemp[10],
            ClientCellNumber: elementtemp[11],
            fake: '',

            Connection: elementtemp[12],
            Activation: elementtemp[13],
            ClientArea: elementtemp[14],
            BatchNumber: elementtemp[15],
          };

          if (temp.ClientName != '') {
            if (!this.ClientNames.includes(temp.ClientName)) {
              this.ClientNames.push(temp.ClientName);
            }
          }

          this.data.push(temp);
        });

        this.SearchValue = {
          Boxno: this.SearchValue.Boxno,
          Provider: this.SearchValue.Provider,

          DateReceived: this.SearchValue.DateReceived,
          Status: this.SearchValue.Status,
          Branch: this.SearchValue.Branch,
          Distributor: this.SearchValue.Distributor,
          Province: this.SearchValue.Province,

          SerialNumber: this.SearchValue.SerialNumber + ',',
          DateDistributed: this.SearchValue.DateDistributed,

          ClientName: this.SearchValue.ClientName,
          ClientProvince: this.SearchValue.ClientProvince,
          ClientCellNumber: this.SearchValue.ClientCellNumber,

          DistributorStartDate: this.SearchValue.DistributorStartDate,
          DistributorEndDate: this.SearchValue.DistributorEndDate,

          RecievedStartDate: this.SearchValue.RecievedStartDate,
          RecievedEndDate: this.SearchValue.RecievedEndDate,

          ConnectionStartDate: this.SearchValue.ConnectionStartDate,
          ConnectionEndDate: this.SearchValue.ConnectionEndDate,

          ActivationStartDate: this.SearchValue.ActivationStartDate,
          ActivationEndDate: this.SearchValue.ActivationEndDate,
          ClientArea: this.SearchValue.ClientArea,
          BatchNumber: this.SearchValue.BatchNumber,
          fake: '2',
        };

        Swal.close();
      } else {
        this.PopupTitle = 'Something went wrong';
        this.DisplayErrormessage =
          'Please check your internet connection and try again';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });
  }

  ViewData(AreaID: string) {
    this.router.navigate(['/ViewSpecificBox', AreaID]);
  }

  ClearSearch() {
    this.SearchValue = {
      Boxno: '',
      DateReceived: '',
      DateDistributed: '',

      Provider: 'All',

      Status: 'Recieved',
      Branch: 'All',
      Distributor: 'All',
      Province: 'All',

      SerialNumber: 'All',

      ClientName: 'All',
      ClientProvince: 'All',
      ClientCellNumber: 'All',
      DistributorStartDate: '',
      DistributorEndDate: '',

      RecievedStartDate: '',
      RecievedEndDate: '',

      ConnectionStartDate: '',
      ConnectionEndDate: '',

      ActivationStartDate: '',
      ActivationEndDate: '',
      ClientArea: '',

      fake: '1',
      BatchNumber: '',
    };

    this.clearData();
    this.getData();
  }

  ClearBoxNoSearch() {
    this.SearchValue.Boxno = '';
    this.Search();
  }

  Search() {
    this.clearData();
    this.getData();
  }

  async btnDownloadReportClickExcel() {
    var formData = new FormData(); // Currently empty

    var SQLQuery = '';

    if (this.SearchValue.Boxno != '') {
      SQLQuery += "AND Boxes.Boxno like '~" + this.SearchValue.Boxno + "%' ";
    }

    if (this.SearchValue.Provider != 'All') {
      SQLQuery += "AND Boxes.Provider='" + this.SearchValue.Provider + "' ";
    }

    if (this.SearchValue.Distributor != 'All') {
      SQLQuery +=
        "AND Boxes.Distributor='" + this.SearchValue.Distributor + "' ";
    }

    if (this.SearchValue.Province != 'All') {
      SQLQuery += "AND Boxes.Province='" + this.SearchValue.Province + "' ";
    }
    if (this.SearchValue.ClientName != 'All') {
      SQLQuery +=
        "AND BoxDetails.Client='" + this.SearchValue.ClientName + "' ";
    }

    if (this.SearchValue.ClientProvince != 'All') {
      SQLQuery +=
        "AND Clients.Province='" + this.SearchValue.ClientProvince + "' ";
    }

    if (
      this.SearchValue.DistributorStartDate != '' &&
      this.SearchValue.DistributorEndDate != ''
    ) {
      SQLQuery +=
        "AND BoxDetails.DateDist between '" +
        this.SearchValue.DistributorStartDate +
        "' AND '" +
        this.SearchValue.DistributorEndDate +
        "' ";
    }

    if (
      this.SearchValue.RecievedStartDate != '' &&
      this.SearchValue.RecievedEndDate != ''
    ) {
      SQLQuery +=
        "AND Boxes.DateReceived between '" +
        this.SearchValue.RecievedStartDate +
        "' AND '" +
        this.SearchValue.RecievedEndDate +
        "' ";
    }

    if (
      this.SearchValue.ConnectionStartDate != '' &&
      this.SearchValue.ConnectionEndDate != ''
    ) {
      SQLQuery +=
        "AND BoxDetails.condate between '" +
        this.SearchValue.ConnectionStartDate +
        "' AND '" +
        this.SearchValue.ConnectionEndDate +
        "' ";
    }
    if (
      this.SearchValue.ActivationStartDate != '' &&
      this.SearchValue.ActivationEndDate != ''
    ) {
      SQLQuery +=
        "AND BoxDetails.actdate between '" +
        this.SearchValue.ActivationStartDate +
        "' AND '" +
        this.SearchValue.ActivationEndDate +
        "' ";
    }

    let Link = '';
    if(this.document.location.hostname.includes('admin.pactel.co.za')){
      Link = "https://admin.pactel.co.za/xdt/assets/php/";
    }else{
      Link = 'http://10.10.10.2/xdt/assets/php/';
    }
    window.open(
      Link + 'exportData.php?status=' +
        this.SearchValue.Status +
        '&SQLQuery=' +
        SQLQuery
    );
  }

  open(content: any) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = 'Closed with: ${result}';
        },
        (reason) => {
          this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
          //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          //element.click();
        }
      );
  }
}
